var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"item":_vm.item,"linked-to":_vm.item.slug || _vm.item.path,"level":_vm.level}})}
var staticRenderFns = []

export { render, staticRenderFns }